import { useQuery } from 'react-query';
import axios from 'axios';
import { BranchAPI } from '../../constants/API';
import { commonHeaders } from '../../constants/HeadersAPI';
import type { BranchQueueItemDto } from './WorkingPlacesTable/useGetQueuesForCurrentUser';

/**
 * Возвращает branch_queue_id для загрузки настроек в зависимости от выбранных филиала и очереди:
 * - если выбраны очереди — первая выбранная очередь;
 * - если выбран только филиал — первая очередь этого филиала;
 * - иначе null (настройки по умолчанию).
 */
export function useEffectiveBranchQueueId(
  filterBranchIds: number[],
  filterQueueIds: number[]
): number | null {
  const firstBranchId =
    filterBranchIds.length > 0 ? filterBranchIds[0] : null;
  const { data: queuesForBranch } = useQuery<BranchQueueItemDto[]>(
    ['branches', firstBranchId, 'queues'] as const,
    () =>
      axios
        .get<BranchQueueItemDto[]>(
          BranchAPI.getQueues(firstBranchId!),
          commonHeaders()
        )
        .then((r) => r.data),
    { enabled: firstBranchId != null && filterQueueIds.length === 0 }
  );

  if (filterQueueIds.length > 0) {
    return filterQueueIds[0];
  }
  if (firstBranchId != null && queuesForBranch?.length) {
    return queuesForBranch[0].id;
  }
  return null;
}
